import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "conversionFactor",
    "convertedBasePrice",
    "convertedPurchasePrice",
    "marketplaceUnit",
    "marketplaceUnitLabel",
    "priceGuidance",
    "unitPrice"
  ]

  static values = {
    basePrice: Number,
    currency: String,
    purchasePrice: Number,
    purchasePriceSet: Boolean
  }

  connect() {
    this.refresh()
  }

  refresh() {
    const conversionFactor = Number(this.conversionFactorTarget.value)
    const marketplaceUnitLabel = this.selectedMarketplaceUnitLabel()

    this.marketplaceUnitLabelTargets.forEach((target) => {
      target.textContent = marketplaceUnitLabel
    })

    if (!Number.isFinite(conversionFactor) || conversionFactor <= 0) {
      this.convertedBasePriceTarget.textContent = "—"
      this.convertedPurchasePriceTarget.textContent = "—"
      this.priceGuidanceTarget.textContent = "Enter a valid unit conversion above to calculate the pricing references."
      return
    }

    const convertedBasePrice = this.basePriceValue / conversionFactor
    const convertedPurchasePrice = this.purchasePriceSetValue ? this.purchasePriceValue / conversionFactor : null

    this.convertedBasePriceTarget.textContent = this.formatCurrency(convertedBasePrice)
    this.convertedPurchasePriceTarget.textContent = convertedPurchasePrice === null ? "—" : this.formatCurrency(convertedPurchasePrice)
    this.unitPriceTarget.placeholder = this.formatDecimal(convertedBasePrice)
    this.priceGuidanceTarget.textContent = this.guidanceText(convertedBasePrice, convertedPurchasePrice, marketplaceUnitLabel)
  }

  selectedMarketplaceUnitLabel() {
    const selectedOption = this.marketplaceUnitTarget.selectedOptions[0]
    return selectedOption?.value ? selectedOption.textContent.trim() : "Marketplace unit"
  }

  guidanceText(convertedBasePrice, convertedPurchasePrice, marketplaceUnitLabel) {
    const enteredPrice = this.unitPriceTarget.value.trim()

    if (enteredPrice === "") {
      return `Leave blank to use the converted base price of ${this.formatCurrency(convertedBasePrice)} per ${marketplaceUnitLabel}.`
    }

    const references = [`base ${this.formatCurrency(convertedBasePrice)}`]
    if (convertedPurchasePrice !== null) references.push(`purchase ${this.formatCurrency(convertedPurchasePrice)}`)

    return `Marketplace price ${this.formatCurrency(Number(enteredPrice))} per ${marketplaceUnitLabel}. Reference: ${references.join(" · ")}.`
  }

  formatCurrency(amount) {
    if (!Number.isFinite(amount)) return "—"

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: this.currencyValue || "AUD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    }).format(amount)
  }

  formatDecimal(amount) {
    if (!Number.isFinite(amount)) return ""

    return Number(amount.toFixed(4)).toString()
  }
}
